import { Close, Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment } from '@mui/material'
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton';
import ArgonInput from 'components/ArgonInput';
import ArgonTypography from 'components/ArgonTypography';
import { postSubmit } from 'global/postFunc';
import React, { useEffect, useState } from 'react'

const EditData = ({
    data,
    ta,
    open,
    handleClose,
    addReq,
    decryptedUser,
    updating,
    setUpdating
}) => {
    const [anggaran, setAnggaran] = useState('')
    const [saving, setSaving] = useState(false)

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    useEffect(() => {
        if (open) {
            console.log(data);
            setAnggaran(data.anggaran_opd?.anggaran || '')
            setSaving(false)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const submit = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/sa/opd/update-anggaran-opd',
            {
                id: data.anggaran_opd?.id || null,
                ta: ta.ta,
                kd_pd: data.kd_pd,
                anggaran: anggaran.replace(/,(?=\d{3})/g, '')
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setAnggaran('')
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleClose()
            }
        )
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            // scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Edit Anggaran OPD</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                        {data.nama_pd}
                    </ArgonTypography>
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Anggaran
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={anggaran}
                        onChange={handleAnggaranChange}
                        autoComplete='off'
                        startAdornment={
                            <InputAdornment position="start">
                                <ArgonTypography component="label" variant="caption" >
                                    Rp
                                </ArgonTypography>
                            </InputAdornment>
                        }
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default EditData